module.exports = __webpack_public_path__ + "img/5.84dc726e.jpg";